/**
 * Résout un chemin de fichier uploadé vers son URL publique.
 *
 * Les fichiers du storage (PDF du CV, images d'articles et de projets) sont
 * servis par l'API sur /storage, pas par le domaine du front : celui-ci tourne
 * derrière `serve -s build`, qui renvoie l'index du SPA pour tout chemin
 * inconnu. Un lien relatif y donne donc la page 404 du site au lieu du fichier.
 *
 * En dev, REACT_APP_API_URL est vide : on retombe sur un chemin relatif, servi
 * directement depuis app/client/public/storage par le serveur de CRA.
 */
const API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

export const storageUrl = (filepath) => {
  if (!filepath) return filepath;

  const value = String(filepath);

  // Déjà absolu (l'API renvoie un champ `url` complet sur les entités récentes)
  if (/^(https?:)?\/\//i.test(value) || value.startsWith('blob:') || value.startsWith('data:')) {
    return value;
  }

  // "./storage/x.pdf" | "storage/x.pdf" | "/storage/x.pdf" → "/storage/x.pdf"
  const absolutePath = value.replace(/^\.*\/*/, '/');

  return `${API_BASE}${absolutePath}`;
};

export default storageUrl;
